module.exports = __webpack_public_path__ + "img/91ne.264a0010.svg";